import React from 'react';
import {alpha, Box, useTheme} from '@mui/material';
import {FontIcon} from '../../components';

export const IconSuccess: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '80px',
        height: '80px',
        bgcolor: alpha(theme.palette.success.light, 0.45),
      }}>
      <FontIcon
        color={theme.palette.success.main}
        size={44}
        icon={'circle-check'}
      />
    </Box>
  );
};
